import varsityFontUrl from '../fonts/varsity_regular.ttf';
import jerseyFontUrl from '../fonts/jersey_M54.ttf';

const loadAppFonts = async () => {
  const classicVarsityFont = new FontFace(
    'ClassicVarsity',
    `url(${varsityFontUrl})`
  );
  await classicVarsityFont.load();
  document.fonts.add(classicVarsityFont);

  const classicJerseyFont = new FontFace(
    'ClassicJersey',
    `url(${jerseyFontUrl})`
  );
  await classicJerseyFont.load();
  document.fonts.add(classicJerseyFont);
};

export { loadAppFonts };
